import { observer } from 'mobx-react-lite';
import {
  RichTextField,
  TextField,
  Widget,
  WidgetProps,
} from '../../../../../components';
import Product from '../../../store/Product';

export default observer(function InstallDialogWidget({
  product,
  ...rest
}: { product: Product } & WidgetProps) {
  return (
    <Widget surface="gray" title="Customize Install Dialog" {...rest}>
      <TextField
        InputLabelProps={{ shrink: true }}
        label="Title"
        name="title"
        onChange={product.extendedFeatures.installDialog.handleChange}
        placeholder="Select Your Download Folder"
        value={product.extendedFeatures.installDialog.title}
      />
      <RichTextField
        label="Description"
        name="description"
        onChange={product.extendedFeatures.installDialog.handleChange}
        value={product.extendedFeatures.installDialog.description}
      />
    </Widget>
  );
});
